import React, {useCallback} from 'react';
import {FormikInput, PhoneInput} from "presentation/common";
import {formatRut} from "presentation/common/helpers/validate/rut/rut";
import {MailIcon} from "presentation/common/components/style-guide/icons";

export const PersonForm = ({name = '', setFieldValue, setFieldTouched}) => {
  const handlePhoneChange = useCallback((v, phoneDetails) => {
    setFieldValue(`${name}phone`, v, true);
    setFieldValue(`${name}countryCode`, phoneDetails.countryCode.toUpperCase());
    setTimeout(() => setFieldTouched(`${name}phone`, true, false));
  }, [setFieldValue, name]);

  return (
    <>
      <FormikInput
        name={`${name}rut`}
        label="RUT"
        required
        setFormat={value => {
          setFieldValue(`${name}rut`, formatRut(value));
          setTimeout(() => setFieldTouched(`${name}rut`, true, false));
        }}
      />

      <FormikInput
        name={`${name}name`}
        label="Nombre"
        required/>

      <FormikInput
        name={`${name}firstName`}
        label="Apellido Paterno"
        required/>

      <FormikInput
        name={`${name}lastName`}
        label="Apellido Materno"/>

      <FormikInput
        Component={PhoneInput}
        country={'cl'}
        name={`${name}phone`}
        label="Teléfono"
        required
        onChange={handlePhoneChange}
      />

      <FormikInput
        required
        prefixIcon={(<MailIcon fill="#9FA6B2"/>)}
        label="Correo Electrónico"
        name={`${name}email`}
      />
    </>
  );
};
